import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import ItemEvento from './ItemEvento';
import './Evento.css';
import { Config } from './Config.js';
import $ from 'jquery'



var cores = ['#fafafa', '#f6f6f6', '#eeeeee']

//var cores = ['#eeeeee', '#ffffff']


class EventoPas extends Component {

    constructor(props) {
        super(props)
        this.state = {
            subprogramas: [],
            mostrarTudo: false
        }

        this.mostrarEtapasAnteriores = this.mostrarEtapasAnteriores.bind(this);
        this.mostrarBotaoVerMais = this.mostrarBotaoVerMais.bind(this);
    }

    componentDidMount() {
        var url = `${Config.apiLink}pas/subprogramas`;

        $.ajax({
            url: url,
            dataType: 'json',
            cache: false,
            success: (result) => {
                this.setState({
                    subprogramas: result
                });
            }
        });

        //fetch(url)
        //    .then(res => {
        //        return res.json();
        //    })
        //    .then(
        //        (result) => {
        //            this.setState({
        //                subprogramas: result
        //            });
        //        },
        //        (error) => {

        //        }
        //    )
    }

    renderItemEvento(eventoNome, eventoVagas, EventoSalario, EventoURL, i, AnoEtapa) {
        return <ItemEvento key={i} EventoNome={eventoNome} EventoVagas={eventoVagas} EventoSalarioMaximo={EventoSalario} EventoURL={EventoURL} AnoEtapa={AnoEtapa}/>;
    }

    renderEventoItems(etapas) {

        return etapas.map((x, i) => {

            return this.renderItemEvento(x.etapaDescricao, null, null, `/subprogramas/${x.periodo}/${x.etapa}`, i, x.anoEtapa)
        });
    }

    mostrarEtapasAnteriores() {
        this.setState({ mostrarTudo: true });
        this.render();
    }

    mostrarBotaoVerMais() {
        if (!this.state.mostrarTudo) {
        return (
            <div className="q_circle_text_holder" style={{ paddingBottom:'85px',paddingTop:'85px' }}>
                <center>
                    <a data-itemprop="url" className="icon_with_title_link" onClick={this.mostrarEtapasAnteriores} target="_self">Ver Mais</a>
                </center>
                </div>);
        }
    }

    RenderEventosAgrupadosPorFase() {

        var subProgramasParaMostrar = this.state.mostrarTudo ? this.state.subprogramas : this.state.subprogramas.filter(c => c.possuiEtapaVigente);

        return subProgramasParaMostrar.map((x, i) => {
            return (
                <div key={i} className="full_width_inner">
                    <div className="vc_row wpb_row section vc_row-fluid  grid_section bg-white" style={{ backgroundColor: x.possuiEtapaVigente ? cores[i] : '#ffffff', borderTop: '1px solid rgb(238, 238, 238)', paddingTop: '87px', paddingBottom: '80px', textAlign: 'left' }}>
                        <div className=" section_inner clearfix">
                            <div className="section_inner_margin clearfix">
                                <div className="wpb_column vc_column_container vc_col-sm-12">
                                    <div className="vc_column-inner">
                                        <div className="wpb_wrapper" style={{ marginBottom: 0 }}>
                                            <div className="wpb_text_column wpb_content_element ">
                                                <div className="wpb_wrapper" style={{ paddingTop: i === 0 ? '85px' : '0px'}}>
                                                    <h2 className="text-center">{x.subProgramaDescricao}</h2>
                                                </div>
                                            </div>
                                            <div className="separator small center"></div>
                                            <div className="separator transparent center"></div>
                                            <div className="itens-container">
                                                <ul className="q_circles_holder five_columns no_line">
                                                    {this.renderEventoItems(x.etapas)}
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <br />
                        </div>
                    </div>
                </div>
            )
        });
    }

    render() {
        return (
            <div>
                <div className="title_outer animate_title_area with_image" data-height="500" style={{ opacity: '0', height: '100px' }}></div>
                <div className="full_width" style={{ paddingTop: '85px' }}>
                    {this.RenderEventosAgrupadosPorFase()}
                    {this.mostrarBotaoVerMais()}
                </div>
            </div >
        );
    }
}

export default EventoPas;
